import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <div className="cyber-spinner" aria-label="Loading" />
    </div>
  );
};

export default LoadingSpinner;
